// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 63) return "app-launcher/63.21201ccd476d173e9c28.js";
	if (chunkId === 444) return "app-launcher/444.d2d7167b4af09d0d13a9.js";
	// return url for filenames based on template
	return undefined;
};